<script setup lang="ts">
import type PaginatedData from "~/types/PaginatedData";
import ChevronDown from "~/components/icons/ChevronDown.vue";

const props = defineProps({
  data: {
    type: Object as PropType<PaginatedData>,
    required: true,
  },
});

function rotateChevron(page: number) {
  if (page === 1) return "rotate-90";
  if (page === props.data.totalPages) return "-rotate-90";

  return page < props.data.currentPage ? "rotate-90" : "-rotate-90";
}
</script>

<template>
  <div>
    <div v-if="data && data.links.length === 1">
      {{ data.links[0].label }}
    </div>

    <ul v-else-if="data">
      <li v-for="link in data.links" :key="link.label" :class="link.active ? 'text-gray-300' : null">
        <!-- Inactive link -->
        <NuxtLink
          v-if="link.url && !link.active"
          :to="link.url"
          class="inline-block px-2 py-1.5 hover:bg-schema-lighter"
        >
          <ChevronDown
            v-if="link.label !== 'First' && link.label !== 'Last'"
            class="inline w-4"
            :class="rotateChevron(link.page)"
          />

          <span v-else>{{ link.label }}</span>
        </NuxtLink>
        <!-- Active link -->
        <span v-else-if="link.url" class="inline-block px-2 py-1.5">
          <ChevronDown
            v-if="link.label !== 'First' && link.label !== 'Last'"
            class="inline w-4"
            :class="rotateChevron(link.page)"
          />

          <span v-else>{{ link.label }}</span>
        </span>
        <!-- Just label -->
        <span v-else class="inline-block px-2 py-1.5">
          {{ link.label }}
        </span>
      </li>
    </ul>
  </div>
</template>

<style scoped>
ul > li {
  @apply inline-block border-y border-l border-gray-300 first:rounded-l last:rounded-r last:border-r;
}
</style>
